'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONNECTIONS_SET = exports.CONNECTIONS_SET = 'CONNECTIONS_SET';
var CONNECTIONS_REMOVE = exports.CONNECTIONS_REMOVE = 'CONNECTIONS_REMOVE';

var BULK_CONNECTIONS_ACTIONS = exports.BULK_CONNECTIONS_ACTIONS = [CONNECTIONS_SET, CONNECTIONS_REMOVE];


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/connectionsConstants.js
// module id = 426
// module chunks = 0